import * as dd from "dingtalk-jsapi";

export const isNotInDingTalk = dd.env.platform === "notInDingTalk";

const readyAsync = () => new Promise((resolve, reject) => {
    dd.ready(resolve);
});

const getPlatForm = () => { // 判断是否处于钉钉内置浏览器
    return !window.dingtalk
        ? "default"
        : "dingding";
};

const requestAuthCodeAsync = dd.runtime.permission.requestAuthCode;
const openLinkAsync = dd.biz.util.openLink;
const openSlidePanelAsync = async (arg) => {
    try {
        await dd.biz.util.openSlidePanel(arg);
    } catch (e) {
        // 避免openSlidePanel 右上角关闭作为出错处理
    }
};

export default {
    readyAsync,
    getPlatForm,
    requestAuthCodeAsync,
    openLinkAsync,
    openSlidePanelAsync,
};
